import React, { useState, useEffect } from "react";
import styled from '@emotion/styled';
import { Popover, IconButton, Button, Divider, Switch, FormControlLabel, Tooltip } from "@mui/material";

import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import PreviewRoundedIcon from '@mui/icons-material/PreviewRounded';
import DisabledVisibleRoundedIcon from '@mui/icons-material/DisabledVisibleRounded';
import CollectionsBookmarkRoundedIcon from '@mui/icons-material/CollectionsBookmarkRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import useLocalStylistsStore from "../../../store/stylists/local";

import useSnackbarStore from "../../../store/snackbar";
import { BasicFlex, LabelUpper } from "../../../utils/Common";

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  align-items: center;
  gap: 1.5rem;
  padding: .6rem 1rem;
  border-bottom: 1px solid ${props => props.theme.colors.border};
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.colors.secondaryFaint};
  }
`;

const BottomButton = styled.div`
  padding: .5rem;
`

const SelectStylistLocal = () => {
  const activeStylists = useLocalStylistsStore((state) => state.activeStylists);
  const tempActiveStylists = useLocalStylistsStore((state) => state.tempActiveStylists);
  const setActiveStylists = useLocalStylistsStore((state) => state.setActiveStylists);
  const setTempActiveStylists = useLocalStylistsStore((state) => state.setTempActiveStylists);
  const handleCheckStylists = useLocalStylistsStore((state) => state.handleCheckStylists);
  const handleCheckAll = useLocalStylistsStore((state) => state.handleCheckAll);

  const showSnackbar = useSnackbarStore((state) => state.showSnackbar);
  
  const [anchorEl, setAnchorEl] = useState(null);

  const [toggleAll, setToggleAll] = useState(false);
  
  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  const updateView = () => {
    setActiveStylists(tempActiveStylists.map(stylist => ({ ...stylist })));
    handleClose();
  }

  const cancelView = () => {
    setTempActiveStylists(activeStylists.map(stylist => ({ ...stylist })));
    handleClose();
  }

  return (
    <>
    <Tooltip title="Filter By Stylist"><IconButton onClick={handleClick} size="small" sx={{padding: ".1rem"}}>
      <PreviewRoundedIcon color="basic" />
    </IconButton></Tooltip>
      <Popover
        id="menu-appbar"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              minWidth: "30rem",
              maxWidth: "35rem",
            },
          }
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
      >
      <BasicFlex mx="1.2rem" my=".5rem" width="auto">
        <LabelUpper $size="1.2rem" $light>Filter Appointments By Stylist</LabelUpper>
        <IconButton onClick={cancelView} size="small">
          <CloseRoundedIcon size="small" />
        </IconButton>
      </BasicFlex>
      <Divider />
      {tempActiveStylists?.map((stylist, index) => (
        <Item key={index} onClick={() => handleCheckStylists(index)}>
          <div>{stylist.full_name}</div>
          <div>
            <IconButton>
              {tempActiveStylists[index]?.checked ? <VisibilityRoundedIcon color="primary" /> : <VisibilityOffRoundedIcon />}
            </IconButton>
          </div>
        </Item>
      ))}
      <BasicFlex mx="1.6rem" my="1rem">
        <FormControlLabel control={<Switch onChange={(e) => handleCheckAll(e.target.checked)} size="small" />} label="Toggle All" />
      </BasicFlex>
      <Divider />
      <BottomButton>
        <Button startIcon={<PreviewRoundedIcon />} color="secondary" onClick={updateView} variant="outlined" fullWidth sx={{marginBottom: ".5rem"}}>Update View</Button>
      </BottomButton>
      </Popover>
    </>
  );
};

export default SelectStylistLocal;